import i18n from "../i18n/i18n";

class UserInfo {

    cookieName = 'userInfo';

    public isPresent(): boolean {
        return !!getCookie(this.cookieName);
    }

    public getUserName(): string {

        const cookieContent = getCookie(this.cookieName);
        const userInfoData = getCookieContent(cookieContent);
        if(userInfoData != null){
            return userInfoData.split('"')[1];
        }else{
            return '';
        }

    }

    public setCookie() : void {
        document.cookie= "userInfo="+encodeURIComponent('["'+this.getUserName()+'",'+i18n.language);
    }
}

function getCookieContent(cookieValue?: string) {
    let result = cookieValue;
    if (!result) {
        return undefined;
    }
    result = decodeURIComponent(result);
    if (!result) {
        return undefined;
    }
    return result;
}

function getCookie(cname: string) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0, length = ca.length; i < length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return undefined;
}

export default new UserInfo();
